import { Link } from 'gatsby'
import { useMenu } from 'src/graphql/queries/menu'
import { checkEnviromentIsB2B } from 'src/utils/checkEnviroment'

interface Props {
  setMenuIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

function FooterContent({ setMenuIsOpen }: Props) {
  const isB2B = checkEnviromentIsB2B()
  const menuData = useMenu()

  const { institutionalLinksMobile } =
    menuData.allCmsHome?.nodes?.[0]?.sections?.[0]?.data

  return (
    <footer className="flex flex-col bg-restructure-background-secondary h-full w-full">
      <nav className="pt-6 pb-8 px-4 flex flex-col">
        <h4 className="mobile-overline-medium desktop-overline-medium text-restructure-secondary mb-[18px] restructure-tablet:mb-4">
          ACESSO RÁPIDO
        </h4>
        <div className="flex flex-col mr-auto">
          {!!institutionalLinksMobile?.length &&
            institutionalLinksMobile.map((link, index) => {
              if (isB2B && link.label === 'Decathlon Empresas') {
                return null
              }

              return (
                <div
                  key={`${link.label}-${index}`}
                  className="block max-w-fit mb-4"
                >
                  {link.href.includes('https') ? (
                    <a
                      className="block mobile-body-regular-text2 desktop-body-regular-text3 text-restructure-primary "
                      href={link.href ?? ''}
                      aria-label={link.label ?? ''}
                      rel="noreferrer"
                      target={link.target}
                      onClick={() => setMenuIsOpen(false)}
                    >
                      {link.label}
                    </a>
                  ) : (
                    <Link
                      className="block mobile-body-regular-text2 desktop-body-regular-text3 text-restructure-primary "
                      to={link.href ?? ''}
                      aria-label={link.label ?? ''}
                      rel="noreferrer"
                      target={link.target}
                      onClick={() => setMenuIsOpen(false)}
                    >
                      {link.label}
                    </Link>
                  )}
                </div>
              )
            })}
        </div>
      </nav>
    </footer>
  )
}

export default FooterContent
